const Spinner = ({ size = '', className = '' }) => (
  <div className={`page-spinner ${className}`}>
    <div className={`spinner-border text-primary ${size === 'sm' ? 'spinner-border-sm' : ''}`} role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

export default Spinner;
